import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const items = [{
  title: 'Ensayas conversaciones',
  desc: 'Repasas una y otra vez lo que dijiste o lo que deberías decir en el futuro.'
}, {
  title: "Sufres de 'Y si...'",
  desc: 'Tu mente viaja automáticamente al peor escenario posible y se queda instalada ahí.'
}, {
  title: 'Agotamiento 11:00 AM',
  desc: 'Te sientes mentalmente rendido antes del mediodía sin haber hecho ningún esfuerzo físico.'
}, {
  title: 'Insomnio por rumiación',
  desc: "El cuerpo está agotado, pero la mente está en plena 'vía rápida' procesando problemas que no puede resolver a las 3 AM."
}, {
  title: 'Buscas una salida técnica',
  desc: "Ya probaste con 'pensar positivo' y fracasaste. Necesitas un protocolo que funcione aunque no creas en él."
}];
export function ForYouSection() {
  return <section className="py-24 bg-navy-900 border-t border-steel-800" data-id="element-70">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-71">
        <FadeIn data-id="element-72">
          <h2 className="text-3xl sm:text-4xl font-bold mb-16 text-center tracking-tight" data-id="element-73">
            ESTO ES PARA TI SI:
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-74">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-75">
              <div className="flex items-start gap-4 p-6 bg-navy-800 border border-steel-800 rounded-sm hover:border-amber-500/50 transition-colors" data-id="element-76">
                <CheckCircle2 className="w-6 h-6 text-amber-500 shrink-0 mt-1" data-id="element-77" />
                <div data-id="element-78">
                  <h3 className="text-xl font-bold text-white mb-2 font-sans" data-id="element-79">
                    {item.title}
                  </h3>
                  <p className="text-offwhite/80 leading-relaxed" data-id="element-80">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}